import Cookies from 'js-cookie';

import _ from 'lodash';
// @ts-expect-error this needs to be added to resolve for jest
// eslint-disable-next-line import/no-unresolved
import getAxiosInstance, { TOKEN_KEY } from 'app/config/api';
import { FAILURE } from '../reducers/action-type';
import { ACTION_TYPES } from '../reducers/auth.reducer';

const removeAuthToken = () => {
  Cookies.remove(TOKEN_KEY);
};

export const displayAuthError = (message: string) => ({
  type: ACTION_TYPES.ERROR_MESSAGE,
  message,
});

export const getProfile = (req: any) => async (dispatch: any) => {
  await dispatch({
    type: ACTION_TYPES.GET_SESSION,
    payload: getAxiosInstance(req).get('users/me'),
  });
};

export const login =
  (email: string, password: string) => async (dispatch: any, getState: any) => {
    removeAuthToken();
    try {
      const tokenRequest = await getAxiosInstance().post('auth/login', {
        email,
        password,
      });

      const jwt = tokenRequest.data.token;

      Cookies.set(TOKEN_KEY, jwt);
      await dispatch({
        type: ACTION_TYPES.LOGIN,
        payload: getAxiosInstance().get('users/me'),
      });
      // the code below needs to be changed. This function should probably not return a value
      return getState().authentication;
    } catch (e) {
      await dispatch({
        type: FAILURE(ACTION_TYPES.LOGIN),
        payload: e,
      });
      throw e;
    }
  };

export const changeActiveMembership =
  (endCustomerOrganizationMembershipId: string) => async (dispatch: any) => {
    try {
      const tokenRequest = await getAxiosInstance().post(
        'users/changeActiveMembership',
        {
          endCustomerOrganizationMembershipId,
        },
      );
      const jwt = tokenRequest.data.token;
      removeAuthToken();
      Cookies.set(TOKEN_KEY, jwt);
      if (localStorage) {
        localStorage.clear();
      }
    } catch (e) {
      await dispatch({
        type: FAILURE(ACTION_TYPES.CHANGE_ACTIVE_MEMBERSHIP),
        payload: e,
      });
      throw e;
    }
    await dispatch({
      type: ACTION_TYPES.CHANGE_ACTIVE_MEMBERSHIP,
      payload: getAxiosInstance().get('users/me'),
    });
    window.location.href = '/app';
  };

export const logout = () => (dispatch: any) => {
  removeAuthToken();
  dispatch({
    type: ACTION_TYPES.LOGOUT,
  });
  window.location.href = '/';
};

export function clearAuthentication() {
  removeAuthToken();
}

// eslint-disable-next-line consistent-return
export const checkAuth = (req: any) => async (dispatch: any, getState: any) => {
  const currentState = getState().authentication;

  if (currentState.hasCheckedIfLoggedIn) {
    return currentState.hasCheckedIfLoggedIn;
  }
  try {
    await dispatch({
      type: ACTION_TYPES.LOGIN,
      payload: getAxiosInstance(req).get('users/me'),
    });
  } catch (err) {
    if (_.get(err, 'response.status') === 401) {
      req.headers.cookie = '';
      removeAuthToken();
      return dispatch({
        type: 'LOGOUT',
      });
    }
  }
};
